// extracted by mini-css-extract-plugin
export var errorIcon = "_ju-1";
export var nameLogo = "_ju-0";